import { PropsWithChildren } from 'react'

import type { TAbsoluteLocale } from '@src/config/localisation/locale-config.types'

import { StatsigBrowserProvider } from './statsig-provider.browser'
import { StatsigServerProvider } from './statsig-provider.server'
import { StatsigUserAgnosticProvider } from './statsig-user-agnostic'
import { getStatsigUser } from './statsig.helpers'

import type { StatsigServerProps } from './statsig.types'

type IsomorphicStatsigProvider = PropsWithChildren<{
  statsigServerProps: StatsigServerProps | null | undefined
  locale: TAbsoluteLocale
  pageOptions: {
    pageType: string | undefined
  }
}>

export function IsomorphicStatsigProvider({
  children,
  statsigServerProps,
  locale,
  pageOptions,
}: IsomorphicStatsigProvider) {
  if (statsigServerProps) {
    return (
      <StatsigServerProvider statsigServerProps={statsigServerProps} pageOptions={pageOptions}>
        {children}
      </StatsigServerProvider>
    )
  }

  const statsigUser = getStatsigUser(locale)
  if (statsigUser) {
    return (
      <StatsigBrowserProvider statsigUser={statsigUser} pageOptions={pageOptions}>
        {children}
      </StatsigBrowserProvider>
    ) //
  }

  return <StatsigUserAgnosticProvider>{children}</StatsigUserAgnosticProvider> //default Provider for Server
}
